import { render } from "./SongsCounter.vue?vue&type=template&id=aa546864&ts=true"
import script from "./SongsCounter.vue?vue&type=script&lang=ts"
export * from "./SongsCounter.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Roshaw\\WebstormProjects\\random-song\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__